import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface Props {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ExitChatAlert = ({ onCancel, onConfirm, open }: Props) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm">
      <DialogTitle>End this conversation?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Closing the chat will end your conversation with Vida. Your messages
          won't be saved.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Keep chatting</Button>
        <Button onClick={onConfirm} variant="secondary">
          End chat
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExitChatAlert;
